import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import {
  computed,
  onBeforeMount,
  watch,
} from 'vue';
import {
  useRouter,
} from 'vue-router';
import Bus, {
  NOTIFICATION,
} from '@/bus';
import {
  redirectUserAfterLogin,
  handleAxiosError,
  CONFIG,
} from '@/helpers';
import SocialLoginService from '@/services/SocialLoginService';
import {
  useStore,
} from '@/store';

interface OneTapResponse {
  credential: string;
  // eslint-disable-next-line camelcase
  select_by: string;
  // eslint-disable-next-line camelcase
  client_id: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleOneTap',
  setup(__props) {


const router = useRouter();
const authStore = useStore.auth;

const user = computed(() => authStore.user);
const token = computed(() => authStore.token);

function _showOneTapCredentialDiv(): void {
  const oneTapCredentialDiv = document.getElementById('credential_picker_container') as HTMLDivElement;
  const oneTapCredentialIframe = document.getElementById('credential_picker_iframe') as HTMLIFrameElement;

  if (!oneTapCredentialDiv && !oneTapCredentialIframe) {
    return;
  }
  if (token.value) {
    if (oneTapCredentialDiv) {
      oneTapCredentialDiv.style.display = 'none';
    }
    if (oneTapCredentialIframe) {
      oneTapCredentialIframe.style.opacity = '0';
      oneTapCredentialIframe.style.top = '-5000px';
    }
    return;
  }
  if (oneTapCredentialIframe) {
    oneTapCredentialIframe.style.opacity = '';
    oneTapCredentialIframe.style.top = '';
    return;
  }
  oneTapCredentialDiv.style.top = '60px';
  oneTapCredentialDiv.style.display = '';
}

watch(() => token.value, () => {
  _showOneTapCredentialDiv();
});

async function _handleOneTapResponse(oneTapResponse: OneTapResponse): Promise<void> {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    const redirectUrl = searchParams.get('redirect') || '';
    const { credential } = oneTapResponse;

    const { isLoggedIn } = await SocialLoginService.performGoogleLogin(redirectUrl, {
      credential,
    });

    if (!isLoggedIn || !user.value) {
      Bus.emit(NOTIFICATION.ERROR, {
        message: 'Login with google failed',
      });
      return;
    }

    // redirect according to role
    const redirection = await redirectUserAfterLogin(user.value, redirectUrl);
    await router.push(redirection.route);
  } catch (e: any) {
    handleAxiosError(e);
  }
}

function _loadGoogleLibrary(): void {
  // reference: https://developers.google.com/identity/one-tap/web/reference/js-reference
  window.onGoogleLibraryLoad = (): void => {
    window.google.accounts.id.initialize({
      client_id: CONFIG.googleAuth2ClientId,
      cancel_on_tap_outside: false,
      callback: _handleOneTapResponse,
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.google.accounts.id.prompt((notification: any) => {
      if (notification.isDisplayed()) {
        _showOneTapCredentialDiv();
      }

      if (notification.isNotDisplayed()) {
        console.log('google one tap not displayed reason: ', notification.getNotDisplayedReason());
      }
    });
  };
}

onBeforeMount(() => {
  _loadGoogleLibrary();
});


return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})